export function dialogueState(dialogue, dirty, writable) {
  return {
    pending: dialogue?.status === 'pending',
    blocked: !!dialogue && (['failed', 'uncertain'].includes(dialogue.status) || !!dialogue.limit_reached),
    canReply: !!dialogue?.can_reply && !dirty && writable && dialogue.status === 'ready' && !dialogue.limit_reached,
  }
}
